<template>
  <v-card elevation="3" color="#FFFFFF">
    <v-card-title class="text"
      >{{ question.literalNumber }} {{ question.question }}</v-card-title
    >

    <!-- question response-->
    <v-card-text>
      <v-autocomplete
        :items="displayOptions"
        label="Seleccione un valor"
        v-model="answerVal"
        :disabled="disabled"
        @change="registerAnswer(questionNumber, answerVal)"
      ></v-autocomplete>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      hints: [],
      hover: [],
      showText: [],
      text: [],
      group1: 1,
      answerVal: "",
      displayOptions: [],
    };
  },
  props: {
    question: Object,
    questionNumber: String,
    answer: String,
    options: Array,
    disabled: Boolean,
  },
  methods: {
    registerAnswer(number, answer) {
      this.$emit("changedAnswer", { number: number, answer: answer });
    },
  },
  components: {},
  async mounted() {
    this.answerVal = this.answer;
    this.displayOptions = this.options.sort();
  },
};
</script>
<style scoped>
.text {
  word-break: normal;
}
</style>